<template>
    <div class="texto" style="text-align:justify">
        Olá <span v-if="profissao === true">Dr(a).</span> {{cliente.pessoa_nome | capitalize }},
    </div>
</template>

<script>
    export default {
        name: 'Saudacao',

        props: {
            cliente: {
                type: Object,
                default: null
            },
        },

        computed: {
            profissao () {
                return [
                    'Médico',
                    'Enfermeiro',
                    'Dentista',
                    'Advogado'
                ].includes(this.cliente.pessoa_profissao)
            }
        },

        methods: {

            plot () {
                return `<table class="saudacao">
                            <tr>
                                <td width="580px">
                                    <p style="font-size:18px;padding-bottom:30px;">Olá ${this.profissao === true ? 'Dr(a).': ''} ${this.$options.filters.capitalize(this.cliente.pessoa_nome)},</p>
                                </td>
                            </tr>
                        </table>`
            }
        }

    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/Saudacao.vue